const API_URL = process.env.REACT_APP_API_URL || 'https://web-production-ef813.up.railway.app';

function getStoredAuth() {
  if (typeof window === 'undefined') return null;

  try {
    return JSON.parse(window.localStorage.getItem('pm_auth') || 'null');
  } catch {
    return null;
  }
}

function getToken() {
  return getStoredAuth()?.token || null;
}

async function parseResponse(response) {
  const text = await response.text();

  if (!text) return null;

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

function getErrorMessage(data, response) {
  if (data && typeof data === 'object') {
    if (typeof data.error === 'string' && data.error.trim()) return data.error;
    if (typeof data.message === 'string' && data.message.trim()) return data.message;
  }

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  return `Erro na requisicao (${response.status})`;
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = new Headers(options.headers || {});
  const requestOptions = { ...options, headers };
  const hasBody = Object.prototype.hasOwnProperty.call(options, 'body');
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  if (hasBody && options.body && !isFormData && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  if (hasBody && options.body && !isFormData && headers.get('Content-Type') === 'application/json' && typeof options.body !== 'string') {
    requestOptions.body = JSON.stringify(options.body);
  }

  const response = await fetch(`${API_URL}${path}`, requestOptions);
  const data = await parseResponse(response);

  if (!response.ok) {
    const error = new Error(getErrorMessage(data, response));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export const auth = {
  register(name, email, password) {
    return apiFetch('/auth/register', {
      method: 'POST',
      body: { name, email, password },
    });
  },
  login(email, password) {
    return apiFetch('/auth/login', {
      method: 'POST',
      body: { email, password },
    });
  },
  getMe() {
    return apiFetch('/auth/me');
  },
  forgotPassword(email) {
    return apiFetch('/auth/forgot-password', {
      method: 'POST',
      body: { email },
    });
  },
  resetPassword(token, password) {
    return apiFetch('/auth/reset-password', {
      method: 'POST',
      body: { token, password },
    });
  },
};

export const onboarding = {
  getOnboarding() {
    return apiFetch('/onboarding').then((data) => {
      if (data?.onboarding?.completed === 1) {
        return { completed: true };
      }

      return { completed: false };
    });
  },
  saveOnboarding(data) {
    return apiFetch('/onboarding', {
      method: 'POST',
      body: data,
    });
  },
};

export const sessions = {
  getSessions() {
    return apiFetch('/sessions');
  },
  getSession(id) {
    return apiFetch(`/sessions/${id}`);
  },
  deleteSession(id) {
    return apiFetch(`/sessions/${id}`, {
      method: 'DELETE',
    });
  },
  analyzeFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('source', 'ggpoker');

    return apiFetch('/analyze', {
      method: 'POST',
      body: formData,
    });
  },
};

export const stats = {
  getOverview() {
    return apiFetch('/stats/overview');
  },
};

export const chat = {
  sendMessage(message, mode = 'default', villain_profile = null) {
    return apiFetch('/chat', {
      method: 'POST',
      body: { message, mode, villain_profile },
    });
  },
  getChatHistory() {
    return apiFetch('/chat');
  },
  clearChat() {
    return apiFetch('/chat', {
      method: 'DELETE',
    });
  },
};

export const memory = {
  getMemory() {
    return apiFetch('/memory');
  },
};

export { API_URL };
